import { defineComponent, reactive } from 'vue';
import { useStore } from 'vuex';
import { SettingTable, SettingTableRow, BasicInput } from '@hems/component';
export default defineComponent({
    name: 'InstallerInfo',
    components: {
        SettingTable,
        SettingTableRow,
        BasicInput,
    },
    setup() {
        const store = useStore();
        const state = reactive({
            data: store.state.device.installation,
        });
        const installationInfo = store.state.device.installation;
        const installerCompany = installationInfo?.installer_company ?? '';
        const installerTelephoneNumber = installationInfo?.installer_tel_num ?? '';
        const installerEmail = installationInfo?.installer_email ?? '';
        return {
            state,
            installerCompany,
            installerTelephoneNumber,
            installerEmail,
        };
    },
});
